import { useQuery } from '@tanstack/react-query';

import { customerStateQueryOptions } from '@/api/customer/customerStateQuery';

import type { UseCustomerStateQueryOptions } from './types';

export const useCustomerStateQuery = ({
  customerId,
  ...options
}: UseCustomerStateQueryOptions) => {
  return useQuery({
    ...customerStateQueryOptions(customerId),
    ...options,
  });
};
